/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAddressDto } from './CreateAddressDto';
import {
    CreateAddressDtoFromJSON,
    CreateAddressDtoFromJSONTyped,
    CreateAddressDtoToJSON,
    CreateAddressDtoToJSONTyped,
} from './CreateAddressDto';

/**
 * Minimal DTO for creating/updating a natural person borrower
 * @export
 * @interface CreateOrUpdateMinimalBorrowerNaturalPersonDto
 */
export interface CreateOrUpdateMinimalBorrowerNaturalPersonDto {
    /**
     * ID of the natural person (null if creation)
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerNaturalPersonDto
     */
    id?: string | null;
    /**
     * ID of the existing borrower (null if creating a new borrower)
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerNaturalPersonDto
     */
    borrowerId?: string | null;
    /**
     * ID of the civility referential (required)
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerNaturalPersonDto
     */
    civilityId: string;
    /**
     * Last name of the person
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerNaturalPersonDto
     */
    lastName: string;
    /**
     * First name of the person
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerNaturalPersonDto
     */
    firstName: string;
    /**
     * Email address of the person
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerNaturalPersonDto
     */
    email: string;
    /**
     * Date of birth of the person (must be at least 16 years old)
     * @type {Date}
     * @memberof CreateOrUpdateMinimalBorrowerNaturalPersonDto
     */
    birthDate: Date;
    /**
     * 
     * @type {CreateAddressDto}
     * @memberof CreateOrUpdateMinimalBorrowerNaturalPersonDto
     */
    address: CreateAddressDto;
}

/**
 * Check if a given object implements the CreateOrUpdateMinimalBorrowerNaturalPersonDto interface.
 */
export function instanceOfCreateOrUpdateMinimalBorrowerNaturalPersonDto(value: object): value is CreateOrUpdateMinimalBorrowerNaturalPersonDto {
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function CreateOrUpdateMinimalBorrowerNaturalPersonDtoFromJSON(json: any): CreateOrUpdateMinimalBorrowerNaturalPersonDto {
    return CreateOrUpdateMinimalBorrowerNaturalPersonDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateMinimalBorrowerNaturalPersonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateMinimalBorrowerNaturalPersonDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'borrowerId': json['borrowerId'] == null ? undefined : json['borrowerId'],
        'civilityId': json['civilityId'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'email': json['email'],
        'birthDate': (new Date(json['birthDate'])),
        'address': CreateAddressDtoFromJSON(json['address']),
    };
}

export function CreateOrUpdateMinimalBorrowerNaturalPersonDtoToJSON(json: any): CreateOrUpdateMinimalBorrowerNaturalPersonDto {
    return CreateOrUpdateMinimalBorrowerNaturalPersonDtoToJSONTyped(json, false);
}

export function CreateOrUpdateMinimalBorrowerNaturalPersonDtoToJSONTyped(value?: CreateOrUpdateMinimalBorrowerNaturalPersonDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'borrowerId': value['borrowerId'],
        'civilityId': value['civilityId'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'email': value['email'],
        'birthDate': ((value['birthDate']).toISOString()),
        'address': CreateAddressDtoToJSON(value['address']),
    };
}

